import type { Layout } from './layout.js';

/**
 * The dashboard every tenant starts with: what the customer overview showed before the
 * studio existed, as a layout. Ids are fixed so the default is stable between installs.
 */
export const DEFAULT_DASHBOARD_LAYOUT: Layout = {
  version: 1,
  nodes: [
    {
      id: 'sec-overview',
      type: 'section',
      props: {
        title: 'Your servers',
        description: 'Live state from each server’s node.',
        width: 'full',
        background: 'none',
        visibility: { audience: 'all', hideOnMobile: false },
      },
      children: [
        {
          id: 'server-overview',
          type: 'server-overview',
          props: { title: '', visibility: { audience: 'all', hideOnMobile: false } },
        },
        {
          id: 'server-list',
          type: 'server-list',
          props: {
            title: '',
            display: 'rows',
            fields: ['status', 'game', 'address', 'players'],
            sort: 'name',
            limit: 12,
            showLink: true,
            visibility: { audience: 'all', hideOnMobile: false },
          },
        },
      ],
    },
    {
      id: 'cols-main',
      type: 'columns',
      props: {
        count: 2,
        ratio: '2:1',
        gap: 'md',
        visibility: { audience: 'all', hideOnMobile: false },
      },
      children: [
        {
          id: 'col-a',
          type: 'column',
          props: {},
          children: [
            {
              id: 'recent-activity',
              type: 'recent-activity',
              props: {
                title: 'Recent activity',
                limit: 8,
                visibility: { audience: 'all', hideOnMobile: false },
              },
            },
          ],
        },
        {
          id: 'col-b',
          type: 'column',
          props: {},
          children: [
            {
              id: 'resource-summary',
              type: 'resource-summary',
              props: {
                title: 'Resources',
                metrics: ['servers', 'memory', 'disk'],
                visibility: { audience: 'all', hideOnMobile: false },
              },
            },
            {
              id: 'ai-shortcut',
              type: 'ai-shortcut',
              props: {
                title: 'Ask Hearth AI',
                body: 'Get help setting up plugins, fixing crashes or tuning your server.',
                prompt: '',
                visibility: { audience: 'all', hideOnMobile: false },
              },
            },
          ],
        },
      ],
    },
  ],
};
